const trim = v => {
	if (typeof v === 'string') {
		return v.trim();
	}

	return v || '';
}

export const computeUserCompositeId = (userid, name) => {
	if (!userid) {
		return name || '';
	}

	if (!name) {
		return userid || '';
	}

	return `${trim(name)} (${trim(userid)})`;
};

const computeUserDisplayText = (userid, name) => {
	if (name) {
		return trim(name);
	}

	return trim(userid);
};

export const transform = v => {
	const {
		line_id,
		confirm_line_id,
		line_guid,
		line_name,

		line_state_id,
		is_latest,

		created_date,
		original_created_date,

		user_id,
		confirm_user_id,
		userid,
		user_full_name,
		user_customer_id,
		user_customer_name,

		created_by_user_id,
		confirm_created_by_user_id,
		created_by_userid,
		created_by_user_full_name,
		created_by_user_customer_id,
		created_by_user_customer_name,

		// deprecated_survey_id, // ignore for now
		// confirm_deprecated_survey_id, // ignore for now
		chart_id,

		primary_survey_guid,
		chart_survey_guid,
		deprecated_survey_guid,

		survey_guid,
		survey_id,
		survey_type,

		customer_name,
	} = v;
	
	const result = {
		state: {
			id: line_state_id,
			isLatest: is_latest,
			created: original_created_date,
			updated: created_date,
		},
		customer: {
			name: customer_name,
		},
		line: {
			isMissing: !confirm_line_id,
			id: line_id,
			name: line_name,
			guid: line_guid,
		},
		owner: {
			isMissing: !confirm_user_id,
			id: user_id,
			userid,
			name: user_full_name,
			compositeId: computeUserCompositeId(userid, user_full_name),
			displayText: computeUserDisplayText(userid, user_full_name),
			customer: {
				id: user_customer_id,
				name: user_customer_name,
			}
		},
		editedBy: {
			isMissing: !confirm_created_by_user_id,
			id: created_by_user_id,
			userid: created_by_userid,
			name: created_by_user_full_name,
			compositeId: computeUserCompositeId(created_by_userid, created_by_user_full_name),
			displayText: computeUserDisplayText(created_by_userid, created_by_user_full_name),
			customer: {
				id: created_by_user_customer_id,
				name: created_by_user_customer_name,
			}
		},
		survey: {
			isMissing: !survey_id,
			id: survey_id,
			guid: survey_guid,
			type: survey_type,
		},
		references: {
			chartId: chart_id,
			primarySurveyGuid: primary_survey_guid,
			chartSurveyGuid: chart_survey_guid,
			deprecatedSurveyGuid: deprecated_survey_guid,
		}
	};

	return result;
};

export default {
	computeUserCompositeId,
	transform
};
